import { Loading } from 'element-ui'
import getParams from '@/util/getParams'
const device = getParams('device')
let loadingCssLoad = false
const setLoadingCssLoad = val => (loadingCssLoad = val)

let customClass = 'global-loading'
const setCustomClass = val => (customClass = val)
let spinner = 'client-portal-loading'
const setSpinnerClass = val => (spinner = val)

let loadingInstance,
  isTimeout = true,
  ajaxCount = 0

function startLoading(method) {
  if (method == 'router') {
    isTimeout = false
  }
  if (method == 'ajax') ajaxCount++
  // 在app中首次加载h5loading启动前再关闭apploading
  if (device && !loadingCssLoad) {
    loadingInstance = {
      close: () => {},
    }
    return
  }
  loadingInstance = Loading.service({
    lock: true,
    fullscreen: true,
    spinner,
    customClass,
    background: 'rgba(0, 0, 0, 0.7)',
  })
}

function endLoading() {
  if (loadingInstance)
    setTimeout(() => {
      isTimeout = true
      if (ajaxCount == 0) loadingInstance.close()
    }, 500)
}

function endAjaxLoading() {
  if (ajaxCount > 0) ajaxCount--
  if (loadingInstance && isTimeout && ajaxCount == 0) loadingInstance.close()
}

function endDomLoading() {
  const element = document.getElementById('web_loading')
  if (element) {
    element.style.display = 'none'
  }
}

export { startLoading, endLoading, endAjaxLoading, setLoadingCssLoad, endDomLoading, setCustomClass, setSpinnerClass }
